"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorMessage = exports.IconSizeStyles = void 0;
var getErrorMessage = function getErrorMessage(type) {
  return "You specified invalid type ".concat(JSON.stringify(type), " to an Icon component. Please double-check your code to make sure a valid type is provided.");
};
exports.getErrorMessage = getErrorMessage;
/**
 * Standard dimensions for icons and the corresponding
 * Tailwind classes that sizes the SVG accordingly
 */
var IconSizeStyles = {
  8: 'h-[8px] w-[8px]',
  16: 'h-[16px] w-[16px]',
  24: 'h-[24px] w-[24px]',
  32: 'h-[32px] w-[32px]'
};
exports.IconSizeStyles = IconSizeStyles;